import { Box, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import CustomRadialChart from '../charts/CustomRadialChart';
import { StatusPossessionType } from '../../types/PurposeType';
import { TOKEN_SFL, TOKEN_TRI } from '../../lib/name-space';

const PossessionByPurpose = ({ type, info }: { type: 'shuffle' | 'trice'; info: StatusPossessionType[] }) => {
  // const isMobile = useMediaQuery('(max-width:900px)');

  const unit = type === 'shuffle' ? TOKEN_SFL : TOKEN_TRI;

  return (
    <Box mt="52.17px">
      <Typography variant="h3" color="#242424">
        Status Of Possession By Purpose
      </Typography>

      <Box mt={{ xs: '20px', md: '20px' }}>
        <Grid container spacing={{ xs: '20px', md: '20px' }}>
          {info.map((possession) => (
            <Grid key={possession.title} size={{ xs: 12, md: 6 }}>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  gap: '12px',
                  borderRadius: '20px',
                  p: '28px 34px 20px 12px',
                  border: '0.5px solid #DFDFDF',
                  boxShadow: '0px 0px 4px 0px #00000015',
                  height: '100%',
                }}
              >
                {/* Box 내용 */}
                <CustomRadialChart possession={possession} />

                <Box
                  sx={{
                    width: { xs: '129px', md: '185px' },
                    display: 'flex',
                    flexDirection: 'column',
                    gap: { xs: '19.5px', md: '12px' },
                  }}
                >
                  {/* title */}
                  <Typography
                    sx={{
                      fontWeight: '700',
                      fontSize: '20px',
                      lineHeight: '18px',
                      letterSpacing: '-0.02em',
                      color: '#333333',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {possession.title}
                  </Typography>

                  {/* Amount */}
                  <Box>
                    <Typography
                      sx={{
                        fontSize: { xs: '11px', md: '12px' },
                        lineHeight: '18px',
                        letterSpacing: '-0.02em',
                        color: '#A5A5A5',
                      }}
                    >
                      Amount
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: { xs: '14px', md: '16px' },
                        lineHeight: { xs: '18px', md: '24px' },
                        letterSpacing: '-0.02em',
                        color: '#242424',
                      }}
                    >
                      {possession.amount} {unit}
                    </Typography>
                  </Box>

                  {/* UnLock Amount */}
                  <Box>
                    <Typography
                      sx={{
                        fontSize: { xs: '11px', md: '12px' },
                        lineHeight: '18px',
                        letterSpacing: '-0.02em',
                        color: '#A5A5A5',
                      }}
                    >
                      UnLock Amount
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: { xs: '14px', md: '16px' },
                        lineHeight: { xs: '18px', md: '24px' },
                        letterSpacing: '-0.02em',
                        color: '#242424',
                      }}
                    >
                      {possession.unlockUmount.toLocaleString()} {unit}
                    </Typography>
                  </Box>

                  {/* Remaining Amount */}
                  <Box>
                    <Typography
                      sx={{
                        fontSize: { xs: '11px', md: '12px' },
                        lineHeight: '18px',
                        letterSpacing: '-0.02em',
                        color: '#A5A5A5',
                      }}
                    >
                      Remaining Amount
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: { xs: '14px', md: '16px' },
                        lineHeight: { xs: '18px', md: '24px' },
                        letterSpacing: '-0.02em',
                        color: '#242424',
                      }}
                    >
                      {possession.remainingAmount.toLocaleString()} {unit}
                    </Typography>
                  </Box>

                  {/* Number Of Wallets */}
                  <Box>
                    <Typography
                      sx={{
                        fontSize: { xs: '11px', md: '12px' },
                        lineHeight: '18px',
                        letterSpacing: '-0.02em',
                        color: '#A5A5A5',
                      }}
                    >
                      Number Of Wallets
                    </Typography>
                    <Box
                      sx={{
                        display: 'flex',
                        gap: '8px',
                        alignItems: 'center',
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: { xs: '14px', md: '16px' },
                          lineHeight: { xs: '18px', md: '24px' },
                          letterSpacing: '-0.02em',
                          color: '#242424',
                        }}
                      >
                        {possession.length}
                      </Typography>
                      {/* <IconButton
                        onClick={() => {
                          const url = `https://polygonscan.com/address/${possession.address}`; // 원하는 URL 입력
                          window.open(url, '_blank', 'noopener,noreferrer'); // 새 창에서 열기
                        }}
                      >
                        <ShareIcon width={isMobile ? 8 : 12} height={isMobile ? 8 : 12} color={'#5D5D5D'} />
                      </IconButton> */}
                      {/* <div
                        onClick={() => {
                          const url = `https://polygonscan.com/address/0xe0EF6617452ABDC606beD1BA82e9BC1c76Dfe7a8`; // 원하는 URL 입력
                          window.open(url, '_blank', 'noopener,noreferrer'); // 새 창에서 열기
                        }}
                      >
                        <ShareIcon width={isMobile ? 8 : 12} height={isMobile ? 8 : 12} color={'#5D5D5D'} />
                      </div> */}
                      {/* {possession.address2 && (
                        <>
                          <Typography
                            sx={{
                              fontSize: { xs: '14px', md: '16px' },
                              lineHeight: { xs: '18px', md: '24px' },
                              letterSpacing: '-0.02em',
                              color: '#242424',
                            }}
                          >
                            {possession.length - 1}
                          </Typography>
                          <IconButton
                            onClick={() => {
                              const url = `https://polygonscan.com/address/${possession.address2}`; // 원하는 URL 입력
                              window.open(url, '_blank', 'noopener,noreferrer'); // 새 창에서 열기
                            }}
                          >
                            <ShareIcon width={isMobile ? 8 : 12} height={isMobile ? 8 : 12} color={'#5D5D5D'} />
                          </IconButton>
                        </>
                      )} */}
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default PossessionByPurpose;
